<template>
    <div v-if="consognment && consognment.tasks && consognment.tasks">
      <div class="container-fluid invoice-container" v-for="task in consognment.tasks" :key="task.id">
        <!-- Header -->
        <header>
            <div class="row align-items-center pt-3">
                <div class="col-12 text-center mb-3 mb-sm-0">
                    <img id="logo" src="../../../assets/imgs/logo.jpg" title="bashundhara" alt="Bashundhara roti" height="120"/>
                </div>
                <div class="col-12 text-center order-sm-1"> 
                  <!-- <img src="../../../assets/imgs/people/qr_code.jpg" height="120"/> -->
                </div>
                <div class="col-12 text-center order-sm-1"> 
                  <strong>{{task.order.unique_id}}</strong>
                </div>
            </div>
        </header>

        <!-- Main Content -->
        <main class="my-3">
          <strong>Shipping Details:</strong>
          <table style="width:100%" class="mt-2">
            <tr>
              <td style="width: 300px;">Customer Name</td>
              <td>{{task.order.customer.name}}</td>
            </tr>
            <tr>
              <td style="width: 300px;">Customer Number</td>
              <td>{{task.order.customer.mobile}}</td>
            </tr>
            <tr>
              <td style="width: 300px;">Customer Address</td>
              <td>{{task.order.customer.address}}</td>
            </tr>
            <tr>
              <td style="width: 300px;">Zone</td>
              <td>{{task.order.zone && task.order.zone.name ? task.order.zone.name : ''}}</td>
            </tr>
          </table>

            <div class="card my-4" style="border-color: transparent;">
              <strong>Product and Pricing Information</strong> 
              <table class="table mb-0 mt-3">
                  <thead>
                      <tr>
                          <td class="border-0" style="width: 300px;"><strong>Products</strong></td>
                          <td class="text-right border-0"><strong>Quantity</strong></td>
                      </tr>
                  </thead>
              </table>
              <table class="table">
                  <tbody>
                      <tr v-for="(product, key) in task.order.details" :key="key">
                          <td class="border-top-none" style="width: 300px;">
                              <strong>{{product.product_name}}</strong> (<strong style="color: green">{{ product.product_type }}</strong>)
                          </td>
                          <td class="text-right border-top-none">
                            {{product.quantity}}
                          </td>
                      </tr>
                      <tr>
                          <td colspan="1" class="bg-light-2 text-right"><strong>Total:</strong></td>
                          <td class="bg-light-2 text-right">{{courntProductQnt(task.order.details)}}</td>
                      </tr>
                  </tbody>
              </table>
            </div>

            <div class="row mt-5">
              <div class="col-6">
                <strong>Merchant Signature</strong>

                <div class="das-das"></div>
              </div>
              <div class="col-6">
                <strong>Customer Signature</strong>
                
                <div class="das-das"></div>
              </div>
            </div>
        </main>
        <!-- Footer -->
        <!-- <footer class="text-center mt-4">
            <p class="text-1"><strong>NOTE :</strong> This is computer generated receipt and does not require physical
                signature.</p>
        </footer> -->

        <div class="html2pdf__page-break"/>
      </div>
    </div>
</template>

<script>
export default {
    props: ['consognment'],
    methods: {
      courntProductQnt(pro) {
        let total = 0;

        if (pro && pro.length) {
          pro.forEach(e => {
            total = total + e.quantity;
          });
        }
        
        return total;
      }
    }
}
</script>

<style lang="scss" scoped>  
  .invoice-container {
        font-size: 10px !important;

        table,thead,tbody, tr, td,th{
            text-align: center;
            margin: auto;
            border: 1px solid #000 !important;
            padding: 10px;
            font-size: 10px;
        }

        .cilavery-content {
            table,thead,tbody, tr, td,th{
                padding: 0.7rem;
            }
        }

        .das-das {
          margin-top: 2rem;
          width: 100%;
          border: 1px dashed;
          margin-bottom: 10px;
        }
  }
</style>